"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaAnalyticsTag = exports.AlgoliaAnalyticsEventAction = exports.AlgoliaAnalyticsEventSource = exports.AlgoliaAnalyticsEventPage = void 0;
var AlgoliaAnalyticsEventPage;
(function (AlgoliaAnalyticsEventPage) {
    AlgoliaAnalyticsEventPage["ProductListingPage"] = "PLP";
    AlgoliaAnalyticsEventPage["ProductDetailPage"] = "PDP";
    AlgoliaAnalyticsEventPage["SearchFlyout"] = "SearchFlyout";
})(AlgoliaAnalyticsEventPage || (exports.AlgoliaAnalyticsEventPage = AlgoliaAnalyticsEventPage = {}));
var AlgoliaAnalyticsEventSource;
(function (AlgoliaAnalyticsEventSource) {
    AlgoliaAnalyticsEventSource["Bestseller"] = "Bestseller";
    AlgoliaAnalyticsEventSource["ProductList"] = "ProductList";
    AlgoliaAnalyticsEventSource["BuyBox"] = "BuyBox";
    AlgoliaAnalyticsEventSource["Recommendations"] = "Recommendations";
    AlgoliaAnalyticsEventSource["SearchFlyout"] = "SearchFlyout";
})(AlgoliaAnalyticsEventSource || (exports.AlgoliaAnalyticsEventSource = AlgoliaAnalyticsEventSource = {}));
var AlgoliaAnalyticsEventAction;
(function (AlgoliaAnalyticsEventAction) {
    AlgoliaAnalyticsEventAction["PageClicked"] = "Page clicked";
    AlgoliaAnalyticsEventAction["ProductClicked"] = "Product clicked";
    AlgoliaAnalyticsEventAction["ProductAddedToCart"] = "Product added to cart";
})(AlgoliaAnalyticsEventAction || (exports.AlgoliaAnalyticsEventAction = AlgoliaAnalyticsEventAction = {}));
var AlgoliaAnalyticsTag;
(function (AlgoliaAnalyticsTag) {
    AlgoliaAnalyticsTag["Desktop"] = "desktop";
    AlgoliaAnalyticsTag["Mobile"] = "mobile";
    AlgoliaAnalyticsTag["Pdp"] = "pdp";
    AlgoliaAnalyticsTag["Plp"] = "plp";
    AlgoliaAnalyticsTag["Search"] = "search";
})(AlgoliaAnalyticsTag || (exports.AlgoliaAnalyticsTag = AlgoliaAnalyticsTag = {}));
//# sourceMappingURL=AlgoliaAnalytics.js.map